import { jsx as _jsx } from "react/jsx-runtime";
import { Button, ComponentSync, LL_V_L, ModuleFE_ActionProcessor } from '@nu-art/thunderstorm-frontend/index';
class PgComponent extends ComponentSync {
    // ######################## Logic ########################
    createMissingDiseaseViewTags = async () => {
        await ModuleFE_ActionProcessor.vv1.execute({ key: 'introduce-and-apply--dp-view-config-tags' }).executeSync();
    };
    // ######################## Render ########################
    render() {
        return _jsx(LL_V_L, { children: this.renderAppConfigDiseaseViewsPreparationButton() });
    }
    renderAppConfigDiseaseViewsPreparationButton = () => {
        return _jsx(Button, { onClick: this.createMissingDiseaseViewTags, children: "Create Missing Disease View Tags" });
    };
}
export const ATS_DevPreps = {
    name: 'Dev Preparations',
    key: 'dev-preparations',
    renderer: PgComponent,
    group: 'Quai Dev Tools',
};
